module.exports = __webpack_public_path__ + "img/assessdis.e1c08c2a.svg";